import 'slick-carousel';
import Plyr from 'plyr';
import { debounce } from "debounce";
let jQuery = require('jquery');



jQuery(document).ready(function() {
  if (jQuery('.threeitem-slider-wrapper .slider-wrapper').length > 0) {
    jQuery('.threeitem-slider-wrapper .slider-wrapper').slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 2,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 939,
          settings: 'unslick'
        },
      ]
    });
  }

  //4items slider
  if (jQuery('.fouritem-slider-wrapper .slider-wrapper').length > 0) {
    jQuery('.fouritem-slider-wrapper .slider-wrapper').slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToShow: 7,
      slidesToScroll: 2,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 939,
          settings: 'unslick'
        },
      ]
    });
  }


  //Page sliders
  if (jQuery('.page-gallery-wrapper .slider-wrapper').length > 0) {
    jQuery('.page-gallery-wrapper .slider-wrapper').slick({
      infinite: false,
      arrows: true,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 2,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: false,
          }
        },
      ]
    });
  }

  if (jQuery('.model-scenes .slider-wrapper').length > 0) {
    jQuery('.model-scenes .slider-wrapper').slick({
      infinite: false,
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 939,
          settings: 'unslick'
        },
      ]
    });
  }

  //Promo Top
  if (jQuery('.promo-block-slider-wrapper').length > 0) {

    // const players = Array.from(document.querySelectorAll('.home-player')).map(p => new Plyr(p));
    // // MUTE UNMUTE
    // let muteButtons = document.querySelectorAll('.mute-button');
    // muteButtons.forEach((function(muteButton) {
    //   muteButton.addEventListener('click', function() {
    //     this.classList.toggle('unmute');

    //     players.forEach(function(player) {
    //       if(player.playing && !player.muted) {
    //         player.muted = true;

    //       } else if (player.playing && player.muted){
    //         player.muted = false;
    //       } else {
    //         return;
    //       }
    //     });
    //   })
    // }));

    // jQuery('.promo-block-slider-wrapper').slick({
    //   infinite: true,
    //   arrows: true,
    //   dots: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 15000,
    //   variableWidth: false,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         arrows: false,
    //         dots: true
    //       }
    //     },
    //   ]
    // });

    // function isScrolledIntoView(elem)
    // {
    //   var docViewTop = jQuery(window).scrollTop();
    //   var docViewBottom = docViewTop + jQuery(window).height();
    //   var elemTop = jQuery(elem).offset().top;
    //   return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    // }

    // window.onscroll = debounce(scrolled, 40);

    // function scrolled(e) {
    //   if (window.pageYOffset > 640) {
    //     jQuery(players).each(function() {
    //       let activeSlide = this.media.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains('slick-current');
    //       let muteButton = document.querySelector('.slick-current .mute-button');
    //       if (activeSlide == true) {
    //         muteButton.classList.add('unmute');
    //         jQuery(this).prop('muted', true);
    //       }
    //     });
    //   }
    //   else {
    //     return
    //   }
    // }

    // Start first video and pause all
    // jQuery(players).each(function() {
    //   this.stop();
    //   let activeSlide = this.media.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains('slick-current')
    //   if (activeSlide == true) {
    //     //console.log(this.media.parentElement.parentElement.parentElement)
    //     jQuery(this.media.parentElement.parentElement.parentElement).show();
    //     this.play().catch(error => {
    //       // Autoplay not allowed!
    //       // Mute video and try to play again
    //       this.muted = true;
    //       this.play();
    //       // Show something in the UI that the video is muted
    //     });
    //   }
    // });

    // On slide change pause video and start the active slide video
    // jQuery('.promo-block-slider-wrapper').on('afterChange', function() {
    //   jQuery(players).each(function(){

    //     //this.parent().hide();
    //     this.stop();
    //     let activeSlide = this.media.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains('slick-current')
    //     if (activeSlide == true) {
    //       jQuery(this.media.parentElement.parentElement.parentElement).show();
    //       jQuery(this).prop('muted', false);
    //       this.play().catch(error => {
    //         // Autoplay not allowed!
    //         // Mute video and try to play again
    //         this.muted = true;
    //         this.play();
    //         // Show something in the UI that the video is muted
    //       });
    //     }
    //   });
    // });
  }

  const promoSlider = document.querySelector('.promo-block-slider-wrapper');
  if(promoSlider){

    jQuery('.promo-block-slider-wrapper').slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 15000,
      variableWidth: false,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            dots: true,
            pauseOnHover: false
          }
        },
      ]
    });
    var time = 15;
    var $bar,
    $slick,
    isPause,
    tick,
    percentTime;

    $bar = document.querySelector('.progressBarSlick');


    const slides = promoSlider.querySelectorAll('.slick-slide');
    // let soundState = true;
    slides.forEach((slide) => {
      const muteButton = slide.querySelector('.mute-button');
      const videoContainer = slide.querySelector('.video-container')
      const playerSelector = slide.querySelector('.home-player');

      if(playerSelector){

        const player = new Plyr(playerSelector, {
          "muted": true
        });

        // INITIALIZE AN OBSERVER SO THAT WHEN SLIDER EXIT VIEPORT THE VIDEOS SHOULD PAUSE
        let promoSliderObserver = new IntersectionObserver(closeVidOnScroll, {
          root: null,
          rootMargin: '0px',
          threshold: 1.0
        });
        promoSliderObserver.observe(promoSlider)
        function closeVidOnScroll(entries, observer){
          entries.forEach(entry => {
            if(entry.isIntersecting){
              isPause = false;
              slideState(slide, player, videoContainer, soundState)
              // jQuery('.promo-block-slider-wrapper').slick('slickPlay');
              // promoBlock.classList.add('transitioning')
              slide.addEventListener('mouseenter', () => isPause = true)
              slide.addEventListener('mouseleave', () => isPause = false)
            } else {
              jQuery('.promo-block-slider-wrapper').slick('slickPause');
              // promoBlock.classList.remove('transitioning')
              // player.restart();
              player.pause();
              isPause = true;
              slide.addEventListener('mouseenter', () => isPause = true)
              slide.addEventListener('mouseleave', () => isPause = true)
            }
          })
        }

        videoContainer.style.display = "block";
        slideState(slide, player, videoContainer, soundState);
        if(player.muted){
          muteButton.classList.remove('unmute')
        } else {
          muteButton.classList.add('unmute')
        }

        muteButton.addEventListener('click', function(event){
          // event.stopPropagation()
          isPause = false;
          if(soundState){
            soundState = false
            player.muted = false
            muteButton.classList.add('unmute')
          } else {
            soundState = true
            player.muted = true
            muteButton.classList.remove('unmute')
          }
        })
        jQuery('.promo-block-slider-wrapper').on('afterChange', function() {
          slideState(slide, player, videoContainer, soundState);
          startProgressbar();
          if(soundState){
            muteButton.classList.remove('unmute')
          } else {
            muteButton.classList.add('unmute')
          }
        })
      }
      // slide.addEventListener('mouseenter', () => promoBlock.classList.remove('transitioning'))
      // slide.addEventListener('mouseleave', () => promoBlock.classList.add('transitioning'))

    })

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      isPause = false;
      tick = setInterval(interval, 10);
    }

    function interval() {
      if(isPause === false) {
        percentTime += 1 / (time+0.1);
        // $bar.css({
        //   width: percentTime+"%"
        // });
        // console.log('percentTime', percentTime)
        $bar.style.width = `${percentTime}%`
        if(percentTime >= 100)
          {
            jQuery('.promo-block-slider-wrapper').slick('slickNext');
            startProgressbar();
          }
      }
    }

    function resetProgressbar() {
      // $bar.css({
      //  width: 0+'%'
      // });
      $bar.style.width = `${percentTime}%`
      clearTimeout(tick);
    }

    startProgressbar();

    const promoBlock = document.querySelector('.promo-block');
    if(promoBlock){
      jQuery('.promo-block-slider-wrapper').on('init', function(){
        // promoBlock.classList.add('transitioning')
      });
      jQuery('.promo-block-slider-wrapper').on('afterChange', function(){
        // promoBlock.classList.add('transitioning')
      });
      jQuery('.promo-block-slider-wrapper').on('beforeChange', function(){
        // promoBlock.classList.remove('transitioning')
      });
    }
    // let promoArrows = promoBlock.querySelectorAll('.slick-arrow')
    // promoArrows.forEach(elem => {
    //   elem.addEventListener('click', function(event){
    //     event.stopPropagation()
    //     elem.blur()
    //     // jQuery('.promo-block-slider-wrapper').slick('slickPlay');
    //     // startProgressbar()
    //   })
    // })
    let promoDots = promoBlock.querySelectorAll('.slick-dots li button')
    if(promoDots){
      promoDots.forEach((elem, index) => {
        elem.addEventListener('click', function(event){
          event.stopPropagation()
          jQuery('.promo-block-slider-wrapper').slick('slickGoTo', index)
          // elem.blur()
          // jQuery('.promo-block-slider-wrapper').slick('slickPlay');
          // startProgressbar()
        })
      })
    }
  }

  function slideState(slide, player, videoContainer, soundState) {
    if (slide.classList.contains('slick-current')) {
      videoContainer.style.display = "block";
      player.muted = soundState;
      player.play();
    } else {
      player.restart();
      player.pause();
      player.muted = true
      videoContainer.style.display = "none";
    }
  }
});
